import { SVGAttributes } from "react";

export const StarIcon = (
  props: SVGAttributes<SVGElement> & { size: "small" }
) => {
  return (
    <svg
      width={16}
      height={16}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M3.306 13.244a1 1 0 001.451 1.054L8 12.593l3.243 1.705a1 1 0 001.45-1.054l-.618-3.611 2.623-2.558a1 1 0 00-.554-1.705l-3.626-.527-1.621-3.286a1 1 0 00-1.794 0L5.482 4.843l-3.626.527a1 1 0 00-.554 1.705l2.624 2.558-.62 3.61zm4.229-2.666L5.62 11.585l.366-2.132a1 1 0 00-.288-.886l-1.549-1.51 2.14-.31a1 1 0 00.754-.548L8 4.26l.957 1.94a1 1 0 00.753.547l2.141.311-1.549 1.51a1 1 0 00-.288.886l.366 2.132-1.915-1.007a1 1 0 00-.93 0z"
        fill="currentColor"
      />
    </svg>
  );
};
StarIcon.displayName = "StarIcon";
